import React, { useContext } from 'react';

import { StaticContext } from '@sm/webassets';
import { Typography } from '@wds/typography';
import { Button } from '@wds/button';
import { Box } from '@wds/box';
import useStyles from './styles';
import './jumbo-header.scss';

const JumboHeader = () => {
  const { headerContainer, headerSubtitle } = useStyles();
  const { user } = useContext(StaticContext);
  return (
    <Box
      px={5}
      pt={5}
      pb={8}
      data-testid="JumboHeader__AppsDirectory"
      display="flex"
      flexDirection="column"
      alignItems="center"
      className={`sm-jumbo-header ${headerContainer}`}
    >
      <Box mb={2}>
        <Typography variant="hero1" component="h1" color="light">
          We&apos;re better together
        </Typography>
      </Box>
      <Box mb={5}>
        <Box className={headerSubtitle}>
          <Typography variant="cardTitle" component="div" color="light" align="center">
            Connect SurveyMonkey with the apps you use daily—gather holistic feedback from the right audience at the
            right time, right place, and take insights-driven actions fast.
          </Typography>
        </Box>
      </Box>
      {!user.isAuthenticated && (
        <Button color="upgrade" href="/user/sign-up">
          Sign up now
        </Button>
      )}
    </Box>
  );
};

export default JumboHeader;
